import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicCheckboxGroupItem} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicCheckboxGroupItem';

export {DynamicCheckboxGroupItem};
export default connectDynamic(DynamicCheckboxGroupItem);
